import { Skeleton, Tooltip } from "antd";
import React from "react";
import useLang from "../../../hooks/useLang";
import { closeDialog, openDialog } from "../../../library/helpers";
import AntdIconV4 from "../../../utils/antdIcon";
import UserSelector from "../../commonComponents/userSelector";
import { AnalyticsPagination, FilterSelector } from "./analyticsComponents";
import BarChart from "./barChart";
import PieChart from "./pieChart";
/**
 *
 * @param {{
 * type: "NORMAL" | "GROUP" | "STACK",
 * xField:string,
 * yField:string,
 * seriesField:string,
 * pagination:
 * boolean |
 * {
 * page?:number,
 * pageSize?:number,
 * total?:number,
 * onChange?:(page:number,pageSize:number)=>void
 * showFilters?:boolean
 * colors?:string[]
 * }}} props
 * @returns
 */
const GraphAnalysis = props => {
  const {
    label,
    graphKey,
    handleGraphChanges,
    graphChanger,
    data,
    filterType,
    setFilterType,
    API,
    loader = false,
    isDialog = false,
    onChangeUsers = () => {},
    userIds = [],
    type = "NORMAL",
    pagination = false,
    showFilters = true,
  } = props;

  const [lang] = useLang();

  const handleFilter = filterType => {
    setFilterType(filterType);
  };

  const handleGraphDialog = () => {
    openDialog("dashboardGraph", {
      dialogHeader: label,
      label,
      graphKey,
      graphChanger,
      handleGraphChanges,
      width: "700",
      isDialog: true,
      filterType,
      setFilterType,
      API,
      data,
      handleFilter,
      handleCancelBtn: () => closeDialog("dashboardGraph"),
      ...props,
    });
  };
  const config = {
    data,
    xField: "userFullName",
    yField: "value",
    isGroup: true,
    padding: "auto",
    seriesField: "name",
    legend: {
      itemName: {
        formatter: (text, item, index) => {
          // Custom logic to rename legend items
          if (text === "sentCount") {
            return "Sent";
          }
          if (text === "receivedCount") {
            return "Received";
          }
        },
      },
    },
    tooltip: {
      formatter: datum => {
        let name = "";
        switch (datum.name) {
          case "receivedCount":
            name = "Received";
            break;
          case "sentCount":
            name = "Sent";
            break;
          default:
            name = "";
        }
        return {
          name,
          value: datum.value,
        };
      },
    },
  };
  return (
    <div className="flex-1 px-2 w-full">
      {showFilters && (
        <div id="antdDropdown" className="flex p-2 w-full justify-between">
          <p className="dashboard-title-label">{label}</p>
          {!isDialog && (
            <div className="flex gap-2 items-center">
              {data?.length > 0 && graphKey !== "messageSentRecieved" && (
                <Tooltip title={lang.barChart}>
                  <div>
                    <AntdIconV4
                      onClick={() => handleGraphChanges(false)}
                      className={`text-2xl cursor-pointer ${
                        !graphChanger ? "labelColor" : ""
                      } hover:-translate-y-1 transition-all ease-in-out delay-75`}
                      type="BarChartOutlined"
                    />
                  </div>
                </Tooltip>
              )}
              {data?.length > 0 && graphKey !== "messageSentRecieved" && (
                <Tooltip title={lang.pieChart}>
                  <div>
                    <AntdIconV4
                      onClick={() => handleGraphChanges(true)}
                      className={`text-2xl cursor-pointer ${
                        graphChanger ? "labelColor" : ""
                      } hover:-translate-y-1 transition-all ease-in-out delay-75`}
                      type="PieChartOutlined"
                    />
                  </div>
                </Tooltip>
              )}
              <FilterSelector filterType={filterType} handleFilter={handleFilter} />
              {graphKey === "messageSentRecieved" && (
                <UserSelector
                  handleUsersSelection={users => onChangeUsers(users)}
                  multiple
                  allEmptyArray
                  className="w-[200px]"
                  userIds={userIds}
                  value={userIds}
                />
              )}
            </div>
          )}
        </div>
      )}
      {/* <Skeleton loading={loader} active> */}

      {loader ? (
        <Skeleton active avatar className="h-[320px]" />
      ) : !graphChanger ? (
        <BarChart {...props} graphData={data} loader={loader} />
      ) : (
        <PieChart graphData={data} loader={loader} />
      )}
      {/* </Skeleton> */}
      {pagination && (
        <AnalyticsPagination
          total={pagination?.total}
          pageSize={pagination?.pageSize || 0}
          length={data?.length}
          onChange={pagination.onChange}
        />
      )}
    </div>
  );
};

export default GraphAnalysis;
